import { render, staticRenderFns } from "./my_classroom.vue?vue&type=template&id=08c44c14&scoped=true&"
import script from "./my_classroom.vue?vue&type=script&lang=js&"
export * from "./my_classroom.vue?vue&type=script&lang=js&"
import style0 from "./my_classroom.vue?vue&type=style&index=0&id=08c44c14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c44c14",
  null
  
)

export default component.exports